import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TrackingService, TrackingInterceptor } from '@vfde-fe/ngx-lib/plugins/tracking';

/** modules  */
@NgModule({
    imports: [CommonModule],
})
/** PluginsModule */
export class PluginsModule {
  /** forRoot */
    public static forRoot (): ModuleWithProviders<any> {
        return {
            ngModule: PluginsModule,
            providers: [
                TrackingInterceptor,
                TrackingService,
            ],
        };
    }
}
